import "../../style/store/store product/Store_Product.css";
import { useSelector } from "react-redux";
import { useState } from "react";
import SPPoster from "./SP_Poster";

// import img1 from '../../../assets/store/amazing-suggest/ella-olsson-KPDbRyFOTnE-unsplash.jpg'
// import img2 from '../../../assets/store/amazing-suggest/antoine-dautry-_zsL306fDck-unsplash.jpg'
// import img3 from '../../../assets/store/amazing-suggest/ahmed-almakhzanji-kshkB1i5_5o-unsplash.jpg'
// import avatar1 from '../../../assets/store/tushar-khandagale-dvtAuBHBAVQ-unsplash.jpg';
import SPBuyBox from "./SP_BuyBox";
import SPUserNum from "./SP_UserNum";

import icon1 from "../../../assets/store/ticket-discount.png";
import SPInfo from "./SP_Info";
import SPDescription from "./SP_Description";

// import video1 from "../../../assets/store/video.mp4";
// import video_cover1 from '../../../assets/store/element5-digital-OyCl7Y4y0Bk-unsplash.jpg';
import SPNecessaryFile from "./SP_NecessaryFile";
import moment from "jalali-moment";


const Store_Product = ({ ID }) => {
  const state = useSelector((state) => state.default);
  const [common_data] = useState(state.ExamData);
  let data;
  for (let i = 0; i < common_data.length; i++) {
    if (common_data[i].id === Number(ID)) {
      data = common_data[i];
    }
  }
  moment.locale("en");
  return (
    <div className="store-product">
      <div className="store-product-sidebar">
        <SPPoster
          img={data.img}
          title={data.name}
        />
        <SPBuyBox
          discount={data.badge}
          discounted_price={data.price}
          price={data.masterPrice}
          ID={data.id}
        />
        <SPUserNum user_num={data.count} />
        <div className="sp-get-discount">
          <img
            className="sp-get-discount-icon"
            src={icon1}
            alt="sp-get-discount-icon"
          />
          <div className="sp-get-discount-text">
            این آزمون رو به دوست معرفی کن و کد تخفیف 20 درصد بگیر. با معرفی
            دوستت و خریدش میتونی کد تخفیف بگیری
          </div>
        </div>
      </div>
      <div className="store-product-main">
        <SPInfo
          title={data.name}
          level={data.level}
          max_user={data.capacity}
          type={data.type}
          creator={data.creator}
          about={data.descripton}
          date={moment(data?.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
          time={moment(data?.date, 'YYYY/MM/DD HH:mm').locale("fa").format('HH:mm')}
        />
        <SPDescription
          descriptin={data.html}
          video={data.video}
          video_cover={data.video_cover}
        />
        <SPNecessaryFile files={data.files}/>
      </div>
    </div>
  );
};

export default Store_Product;
